export default "__VITE_PUBLIC_ASSET__4e1ce417__"